import { Control, FieldValues } from 'react-hook-form';

import { DayPortion } from '../../types/time-off-request';
import { TimeOffRequestDurationRow } from './time-off-request-duration-row';

export interface TimeOffDayListItem {
  date: string;
  isWorkingDay?: boolean;
}

interface TimeOffDayListProps<T extends FieldValues> {
  control: Control<T>;
  days: TimeOffDayListItem[];
  /** Builds the RHF field-name prefix for a day index (e.g. `days.${i}`). */
  fieldPrefix: (index: number) => string;
  disabled: boolean;
  /** Create mode: policy-allowed portions (passed through to each row). */
  allowedPortions?: DayPortion[];
}

/**
 * List of per-day duration rows in normal document flow. The page owns the
 * vertical scroll (the right-side balance card is sticky), so the list grows
 * naturally instead of nesting its own scroll container — nested scrolling here
 * behaved poorly, especially on mobile.
 */
export const TimeOffDayList = <T extends FieldValues>({
  control,
  days,
  fieldPrefix,
  disabled,
  allowedPortions,
}: TimeOffDayListProps<T>) => (
  <div className="flex flex-col gap-2">
    {days.map((day, index) => {
      const prefix = fieldPrefix(index);
      return (
        <TimeOffRequestDurationRow
          key={`${day.date}-${index}`}
          control={control}
          date={day.date}
          portionName={`${prefix}.portion` as never}
          dayPartNumberName={`${prefix}.dayPartNumber` as never}
          minutesName={`${prefix}.minutes` as never}
          isWorkingDay={day.isWorkingDay}
          disabled={disabled}
          allowedPortions={allowedPortions}
        />
      );
    })}
  </div>
);
